import type { AxiosInstance } from 'axios';
import { SUBSCRIPTION_EVENTS_ENDPOINTS } from './endpoints';
import type { ApiEnvelope, SubscriptionEventListApiResponse } from './types';

/** HTTP client type for collection-status event operations. */
export type SubscriptionEventsHttpClientType = {
  list: () => Promise<SubscriptionEventListApiResponse>;
};

/**
 * Creates the HTTP client for collection-status events.
 *
 * Targets `GET /v1/events` in parrot-subscriptions-api; org filtering is
 * derived from the JWT. Unwraps the standard `{data, datetime}` envelope.
 */
export const createSubscriptionEventsHttpClient = (props: {
  httpClientSubscription: AxiosInstance;
}): SubscriptionEventsHttpClientType => {
  const { httpClientSubscription } = props;

  const list = async (): Promise<SubscriptionEventListApiResponse> => {
    const response = await httpClientSubscription.get<ApiEnvelope<SubscriptionEventListApiResponse>>(
      SUBSCRIPTION_EVENTS_ENDPOINTS.LIST,
    );

    return response.data.data;
  };

  return { list };
};
